import React, { useEffect, useState, } from 'react'
import { Modal } from 'react-bootstrap';
import HtmlParser from 'react-html-parser';
import axios from 'axios';

import 'react-tempusdominus-bootstrap';
import moment from 'moment-timezone';

import {
    buttonProcessGet, responseGet, globalSettings, styles, validateDecimals, sendMessageCloseCurrentWindowAsync, dateTimeFormatGlobalSet, separatorsNumbersSet,
    languageObjGet, isUndNullEmp, numberSet, awaitDelay,
} from '../../helpers/settings'
import { buildingModelGet } from '../../models/buildings/building';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { inventoryModelGet } from '../../models/inventories/inventory';

const currentMethod = 'InventoryAddEditDetails';

const { icons, labels, messages, } = globalSettings;

export default function InventoryAddEditDetails({
    $ = {},
    auth = {},
    showModal = false,
    setShowModal = () => { },
    building = buildingModelGet({}),
    buildingTwo = buildingModelGet({}),
    inventory = inventoryModelGet({}),
    setInventory = () => { },
    processValues = {
        auth: {},
        user: {},
        dtId: '',
        rowIndex: 0,
        type: 0,
    },
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const manufacturedId = 'manufactured';
    const [descriptionError, setDescriptionError] = useState('');
    const [brandError, setBrandError] = useState('');
    const [modelError, setModelError] = useState('');
    const [manufacturedError, setManufacturedError] = useState('');
    const [serialError, setSerialError] = useState('');
    const [typeError, setTypeError] = useState('');
    const [costError, setCostError] = useState('');
    const controls = {
        buttons: {
            save: {
                className: 'btn btn-outline-warning mx-1',
                id: 'btnModalInventoriesSave',
            },
            back: {
                className: 'btn btn-outline-success',
                id: 'btnModalInventoriesBack',
            },
            close: {
                className: 'close btn-danger fas fa-window-close',
                id: 'btnModalInventoriesClose',
            },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        // dataTables: {
        //     buildings: {
        //         inputs: {
        //             search: {
        //                 id: `${dtBuildingsId}_filter input`,
        //                 className: '',
        //             },
        //         },
        //         selects: {
        //             entries: {
        //                 id: `${dtBuildingsId}_length select`,
        //                 className: '',
        //             },
        //         },
        //     },
        // },
        icons: {
            save: {
                id: 'iconModalInventoriesSave',
                className: icons?.save,
            },
            back: {
                id: 'iconModalInventoriesBack',
                className: icons?.arrowCircleLeft,
            },
        },
        inputs: {
            name: {
                id: 'inputModalInventoriesName',
                className: 'form-control',
            },
            brand: {
                id: 'inputModalInventoriesBrand',
                className: 'form-control',
            },
            model: {
                id: 'inputModalInventoriesModel',
                className: 'form-control',
            },
            manufactured: {
                id: 'inputModalInventoriesManufactured',
                className: 'form-control datetimepicker-input',
            },
            serial: {
                id: 'inputModalInventoriesSerial',
                className: 'form-control',
            },
            type: {
                id: 'inputModalInventoriesType',
                className: 'form-control',
            },
            cost: {
                id: 'inputModalInventoriesCost',
                className: 'form-control text-right',
            },
        },
        // radios: {
        //     even: {
        //         id: 'radioModalInventoriesEven',
        //         className: 'icheck-primary d-inline mx-4',
        //     },
        //     odd: {
        //         id: 'radioModalInventoriesOdd',
        //         className: 'icheck-primary d-inline',
        //     },
        //     both: {
        //         id: 'radioModalInventoriesBoth',
        //         className: 'icheck-primary d-inline mx-4',
        //     },
        // },
        spinners: {
            save: {
                id: 'spModalInventoriesSave',
                className: '',
            },
            back: {
                id: 'spModalInventoriesBack',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion variables

    //#region methods
    const defaultValueSetAsync = async ({ isModalClose = false, subMethod = '', }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            if (isModalClose) {
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });

                response = await errosDefaultSetAsync({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                    return;
                }

                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                setShowModal(!isModalClose);
            }
            buildingTwo = building;
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const formDataSetAsync = async ({ property = '', value = '', subMethod = '', }) => {
        const currentMethod = 'formDataSetAsync';
        let response = responseGet();
        try {
            setInventory({ ...inventory, [property]: value, });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    const formDataValidateAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'formDataValidateAsync';
        let response = responseGet();
        try {
            if (isUndNullEmp({ data: inventory?.description, subMethod: currentMethod, })?.result) {
                setDescriptionError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: inventory?.brand, subMethod: currentMethod, })?.result) {
                setBrandError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: inventory?.model, subMethod: currentMethod, })?.result) {
                setModelError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: inventory?.manufactured, subMethod: currentMethod, })?.result) {
                setManufacturedError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: inventory?.type, subMethod: currentMethod, })?.result) {
                setTypeError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const errosDefaultSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'errosDefaultSetAsync';
        let response = responseGet();
        try {
            setDescriptionError('');
            setBrandError('');
            setModelError('');
            setManufacturedError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const inventoryAddPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'inventoryAddPostAsync';
        let response = responseGet();
        try {
            //#region variables
            let inventoryFound = [];
            //#region response is warning
            let responseIsWarning = responseGet();
            responseIsWarning.isWarning = true;
            responseIsWarning.msgType = 1;
            //responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
            //#endregion response is warning
            //#endregion variables

            //#region initialize
            e?.preventDefault();

            response = await errosDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = await dataInventorySetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion initialize

            //#region data save
            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region find inventory
            if (isUndNullEmp({ data: building?.inventories, subMethod: currentMethod, })?.result) {
                building.inventories = [];
            }

            //#region by description
            inventoryFound = building?.inventories?.find(({ description }) => description === inventory?.description);
            if (!isUndNullEmp({ data: inventoryFound, subMethod: currentMethod, })?.result) {
                responseIsWarning.msgText = `${messages?.thisInformationHasAlreadyBeenRecorded?.[languageObj?.id]}:<br/>`;
                responseIsWarning.msgText += `<b>${inventory?.description}</b><br/>`;
                responseIsWarning.msgText += `${messages?.pleaseEnterDifferentOne?.[languageObj?.id]}`;
                await sendMessageCloseCurrentWindowAsync({
                    msgType: responseIsWarning?.msgType,
                    msgText: !isUndNullEmp({ data: responseIsWarning?.msgHtml, subMethod: currentMethod, })?.result ? responseIsWarning?.msgHtml : responseIsWarning?.msgText,
                    closeWindow: false,
                    urlGoTo: responseIsWarning?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion by description

            //#region by serial
            inventoryFound = building?.inventories?.find(({ serial }) => serial === inventory?.serial && serial !== '');
            if (!isUndNullEmp({ data: inventoryFound, subMethod: currentMethod, })?.result) {
                responseIsWarning.msgText = `${messages?.thisInformationHasAlreadyBeenRecorded?.[languageObj?.id]}:<br/>`;
                responseIsWarning.msgText += `<b>${inventory?.serial}</b><br/>`;
                responseIsWarning.msgText += `${messages?.pleaseEnterDifferentOne?.[languageObj?.id]}`;
                await sendMessageCloseCurrentWindowAsync({
                    msgType: responseIsWarning?.msgType,
                    msgText: !isUndNullEmp({ data: responseIsWarning?.msgHtml, subMethod: currentMethod, })?.result ? responseIsWarning?.msgHtml : responseIsWarning?.msgText,
                    closeWindow: false,
                    urlGoTo: responseIsWarning?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion by serial
            //#endregion find inventory

            //#region update inventories
            building?.inventories?.push(inventory);

            headerObj = {
                headers: {
                    authorization: `bearer ${processValues?.auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };
            dataObj = {
                inventories: building.inventories,
                languageId: languageObj?.id,
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlInventories}/${building.id}`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );
            response = result.data;

            if (!response?.isSuccess || response?.isWarning) {
                building.inventories = building?.inventories?.filter(({ id }) => id !== inventory?.id);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            //#endregion update inventories
            $(`#${processValues?.dtId}`)?.DataTable()?.row?.add([
                inventory?.description,
                inventory?.type,
                inventory?.brand,
                inventory?.model,
                buttonProcessGet({
                    id: inventory?.id,
                    description: inventory?.description,
                    showDetails: true,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: true,
                    showDelete: true,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: true,
                    processButtons: [],
                })?.result
            ])?.draw(true);

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });

            //sendMessage(0, messages?.processesCompletedSuccessfully?.[languageObj?.id], 0, true, false, null, '');
            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: '',
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            //#endregion data save
        } catch (ex) {
            building.inventories = building.inventories.filter(({ id }) => id !== inventory?.id);
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    const inventoryEditPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'inventoryEditPostAsync';
        let response = responseGet();
        try {
            //#region variables
            let inventoryFound = [];
            //#region response is warning
            let responseIsWarning = responseGet();
            responseIsWarning.isWarning = true;
            responseIsWarning.msgType = 1;
            //responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
            //#endregion response is warning
            //#endregion variables

            //#region initialize
            e.preventDefault();
            response = await errosDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = await dataInventorySetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion initialize

            //#region data save
            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region Fidn inventory
            if (isUndNullEmp({ data: building?.inventories, subMethod: currentMethod, })?.result) {
                building.inventories = [];
            }

            //#region by description
            inventoryFound = building?.inventories?.find(({ id, description }) => description === inventory?.description && id !== inventory?.id);
            if (!isUndNullEmp({ data: inventoryFound, subMethod: currentMethod, })?.result) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                responseIsWarning.msgText = `${messages?.thisInformationHasAlreadyBeenRecorded?.[languageObj?.id]}:<br/>`;
                responseIsWarning.msgText += `<b>${inventory?.description}</b><br/>`;
                responseIsWarning.msgText += `${messages?.pleaseEnterDifferentOne?.[languageObj?.id]}`;
                await sendMessageCloseCurrentWindowAsync({
                    msgType: responseIsWarning?.msgType,
                    msgText: !isUndNullEmp({ data: responseIsWarning?.msgHtml, subMethod: currentMethod, })?.result ? responseIsWarning?.msgHtml : responseIsWarning?.msgText,
                    closeWindow: false,
                    urlGoTo: responseIsWarning?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion by description

            //#region by serial
            inventoryFound = building?.inventories?.find(({ id, serial }) => serial === inventory?.serial && serial !== '' && id !== inventory?.id);
            if (!isUndNullEmp({ data: inventoryFound, subMethod: currentMethod, })?.result) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                responseIsWarning.msgText = `${messages?.thisInformationHasAlreadyBeenRecorded?.[languageObj?.id]}:<br/>`;
                responseIsWarning.msgText += `<b>${inventory.serial}</b><br/>`;
                responseIsWarning.msgText += `${messages?.pleaseEnterDifferentOne?.[languageObj?.id]}`;
                await sendMessageCloseCurrentWindowAsync({
                    msgType: responseIsWarning?.msgType,
                    msgText: !isUndNullEmp({ data: responseIsWarning?.msgHtml, subMethod: currentMethod, })?.result ? responseIsWarning?.msgHtml : responseIsWarning?.msgText,
                    closeWindow: false,
                    urlGoTo: responseIsWarning?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion by serial
            //#endregion find inventory

            //#region delete element from inventories
            building.inventories = building?.inventories?.filter(({ id }) => id !== inventory?.id);
            //#endregion delete element from inventories

            //#region update inventory
            building?.inventories?.push(inventory);

            headerObj = {
                headers: {
                    authorization: `bearer ${processValues?.auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };
            dataObj = {
                inventories: building?.inventories,
                languageId: languageObj?.id,
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlInventories}/${building?.id}`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                building.inventories = building?.inventories?.filter(({ id }) => id !== inventory?.id);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            //#endregion update inventory
            $(`#${processValues?.dtId}`)?.DataTable()?.row(processValues?.rowIndex)?.data?.([
                inventory?.description,
                inventory?.type,
                inventory?.brand,
                inventory?.model,
                buttonProcessGet({
                    id: inventory?.id,
                    description: inventory?.description,
                    showDetails: true,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: true,
                    showDelete: true,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: true,
                    processButtons: [],
                })?.result
            ])?.draw(true);

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: '',
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            //#endregion data save
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            building.inventories = building.inventories.filter(({ id }) => id !== inventory?.id);
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    const dataInventorySetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataInventorySetAsync';
        let response = responseGet();
        try {
            const manufactured = $(`#${manufacturedId}`)?.datetimepicker('date')?._d;
            inventory.manufactured = !isUndNullEmp({ data: manufactured, subMethod: currentMethod, })?.result ? manufactured.toString() : '';
            inventory.cost = numberSet({
                number: inventory?.cost,
                type: 'd',
                subMethod: currentMethod,
            })?.result;
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    // const dateInControlSet = (date, manufactured) => {
    //     let response = responseGet();
    //     try {
    //         let localDate = '';
    //         const localDateFormat = globalSettings?.react?.tempusDominus?.format?.date?.dmy;
    //         const localDateFormatTwo = globalSettings?.react?.tempusDominus?.format?.date?.DDMMYYYY;

    //         if (!isUndefined(manufactured) && !isNull(manufactured)) {
    //             localDate = dateTimeFormatGlobalSet(manufactured, localDateFormat, 0, false).result;
    //         } else if (!isUndefined(date) && !isNull(date)) {
    //             localDate = dateTimeFormatGlobalSet(date, localDateFormat, 0, false).result;
    //         }

    //         $(`#${manufacturedId}`)?.datetimepicker({
    //             date: moment(`${localDate}`, `${localDateFormatTwo}`),
    //             default: false,
    //             format: `${localDateFormatTwo}`,
    //         });
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: dateInControlSet<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //     }
    //     return response;
    // }

    const dateInControlSet = ({ date = new Date(), manufactured = undefined, subMethod = '', }) => {
        let response = responseGet();
        try {
            //#region variables
            const dateTimeObj = {
                date: '',
                format: languageObj?.format?.date?.f1,
                //formatTwo: `${languageObj?.format?.date?.f11} ${languageObj?.format?.time?.picker?.hhmm}`,
                formatTwo: languageObj?.format?.date?.f11,
            };
            //#endregion variables

            //#region Method
            if (!isUndNullEmp({ data: manufactured, subMethod: currentMethod, })?.result) {
                dateTimeObj.date = dateTimeFormatGlobalSet({
                    date: manufactured,
                    type: dateTimeObj?.format,
                    format: 0,
                    addTime: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            } else if (!isUndNullEmp({ data: date, subMethod: currentMethod, })?.result) {
                dateTimeObj.date = dateTimeFormatGlobalSet({
                    date: date,
                    type: dateTimeObj?.format,
                    format: 0,
                    addTime: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            }

            $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
                icons: globalSettings?.react?.tempusDominus?.icons,
                buttons: globalSettings?.react?.tempusDominus?.buttons,
                tooltips: globalSettings?.react?.tempusDominus?.tooltips({ languageId: languageObj?.id }),
                locale: languageObj?.id,
            });

            $(`#${manufacturedId}`)?.datetimepicker({
                date: moment(dateTimeObj?.date, `${dateTimeObj?.formatTwo}`),
                default: false,
                format: `${dateTimeObj?.formatTwo}`,
            });
            //#endregion Method
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            response = dateInControlSet({
                date: new Date(),
                manufactured: inventory?.manufactured || undefined,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
        } catch (ex) {
            //controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.removeClass();

                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.removeClass();

                    $(`#${controls?.buttons?.back?.id}`)?.removeClass();

                    $(`#${controls?.icons?.save?.id}`)?.addClass(controls?.icons?.save.className);
                    $(`#${controls?.buttons?.save?.id}`)?.addClass(controls?.buttons?.save?.className);
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(controls?.spinners?.save?.className);

                    $(`#${controls?.icons?.back?.id}`)?.addClass(controls?.icons?.back.className);
                    $(`#${controls?.buttons?.back?.id}`)?.addClass(controls?.buttons?.back?.className);
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(controls?.spinners?.back?.className);

                    $(`#${controls?.buttons?.close?.id}`)?.addClass(controls?.buttons?.close?.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.inputs?.name?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.brand?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.model?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.manufactured?.id}`)?.attr('disabled', (processType !== 0));
            $(`#${controls?.inputs?.serial?.id}`)?.attr('readOnly', (processType !== 0));

            $(`#${controls?.inputs?.type?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.cost?.id}`)?.attr('readOnly', (processType !== 0));
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region old code
            // $(`#${controls?.dataTables?.buildings?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            // $(`#${controls?.dataTables?.buildings?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));
            //#endregion old code

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
    }, [auth]); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <Modal backdrop='static' show={showModal} onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'modal - headerCloser', })}>
            <Modal.Header>
                <Modal.Title>
                    <img alt={labels?.inventory?.[languageObj?.id]}
                        src={globalSettings?.images?.inventoriesLogo}
                        style={styles?.cardHeaderLogo}></img> - {labels?.inventory?.[languageObj?.id]} ({processValues?.type === 0 ?
                            labels?.add?.[languageObj?.id]?.toLowerCase() :
                            processValues?.type === 1 ?
                                labels?.edit?.[languageObj?.id]?.toLowerCase() :
                                labels?.detail?.[languageObj?.id]?.toLowerCase()})
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'modal - headerCloser', })}>
                </button>
            </Modal.Header>
            <form onSubmit={(e) => processValues?.type === 0 ?
                inventoryAddPostAsync({ e: e, subMethod: 'modal - btnAdd', }) : processValues?.type === 1 ?
                    inventoryEditPostAsync({ e: e, subMethod: 'modal - btnAdd', }) : e?.preventDefault()}>
                <Modal.Body>
                    {/* <div className='card card-primary card-outline shadow' > */}
                    {/* <form onSubmit={(e) => processValues?.type === 0 ? inventoryAddPostAsync(e) : processValues?.type === 1 ? inventoryEditPostAsync(e) : e?.preventDefault()}> */}

                    {/* Header */}
                    {/* <div className='card-header'>
                            <h6 className='card-title'><img alt={labels?.inventory?.[languageObj?.id]} src={globalSettings?.images?.inventoriesLogo} style={styles?.cardHeaderLogo}></img> - {labels?.inventory?.[languageObj?.id]}</h6>
                        </div> */}

                    {/* Body */}
                    {/* <div className='card-body'> */}
                    {processValues?.type !== 2 ?
                        <div>
                            <div className='form-group'>
                                <div className='input-group mb-3'>
                                    <input id={controls?.inputs?.name?.id}
                                        className={controls?.inputs?.name?.className}
                                        //autoFocus
                                        placeholder={labels?.name?.[languageObj?.id]}
                                        onChange={(e) => formDataSetAsync({ property: 'description', value: e?.target?.value, subMethod: 'input - name', })}
                                        onFocus={() => setDescriptionError('')}
                                        value={inventory?.description || ''}
                                        tooltip='tooltip' title={labels?.name?.[languageObj?.id]} />
                                    <div className='input-group-append'>
                                        <div className='input-group-text'>
                                            <span className={icons?.spellCheck} />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(descriptionError)}</div>
                            </div>

                            <div className='row'>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.brand?.id}
                                                className={controls?.inputs?.brand?.className}
                                                placeholder={labels?.brand?.[languageObj?.id]}
                                                onChange={(e) => formDataSetAsync({ property: 'brand', value: e?.target?.value, subMethod: 'input - brand', })}
                                                onFocus={() => setBrandError('')}
                                                value={inventory?.brand || ''}
                                                tooltip='tooltip' title={labels?.brand?.[languageObj?.id]} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.fasFa?.copyright} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(brandError)}</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.model?.id}
                                                className={controls?.inputs?.model?.className}
                                                placeholder={labels?.model?.[languageObj?.id]}
                                                onChange={(e) => formDataSetAsync({ property: 'model', value: e?.target?.value, subMethod: 'input - model', })}
                                                onFocus={() => setModelError('')}
                                                value={inventory?.model || ''}
                                                tooltip='tooltip' title={labels?.model?.[languageObj?.id]} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.fasFa?.ad} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(modelError)}</div>
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        {/* <DatePicker /> */}
                                        <div className='input-group mb-3'>
                                            <div className='input-group date' id={manufacturedId} data-target-input='nearest'>
                                                <input id={controls?.inputs?.manufactured?.id}
                                                    className={controls?.inputs?.manufactured?.className}
                                                    //className='form-control datetimepicker-input'
                                                    data-target={`#${manufacturedId}`}
                                                    data-toggle='datetimepicker'
                                                    onFocus={() => setManufacturedError('')}
                                                    placeholder={labels?.manufactured?.[languageObj?.id]}
                                                    //tabIndex={-1}
                                                    tooltip='tooltip' title={labels?.manufactured?.[languageObj?.id]}
                                                    type='text' />
                                                <div className='input-group-append' data-target={`#${manufacturedId}`} data-toggle='datetimepicker'>
                                                    <div className='input-group-text'><i className={icons?.calendarAlt}></i></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(manufacturedError)}</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.serial?.id}
                                                className={controls?.inputs?.serial?.className}
                                                placeholder={labels?.serial?.[languageObj?.id]}
                                                onChange={(e) => formDataSetAsync({ property: 'serial', value: e?.target?.value, subMethod: 'input - serial', })}
                                                onFocus={() => setSerialError('')}
                                                value={inventory?.serial || ''}
                                                tooltip='tooltip' title={labels?.serial?.[languageObj?.id]} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.fasFa?.barCode} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(serialError)}</div>
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.type?.id}
                                                className={controls?.inputs?.type?.className}
                                                placeholder={labels?.type?.[languageObj?.id]}
                                                onChange={(e) => formDataSetAsync({ property: 'type', value: e?.target?.value, subMethod: 'input - type', })}
                                                onFocus={() => setTypeError('')}
                                                value={inventory?.type || ''}
                                                tooltip='tooltip' title={labels?.type?.[languageObj?.id]} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.stream} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(typeError)}</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.cost?.id}
                                                className={controls?.inputs?.cost?.className}
                                                //className='form-control text-right'
                                                placeholder={labels?.cost?.[languageObj?.id]}
                                                onChange={(e) => formDataSetAsync({
                                                    property: 'cost',
                                                    //value: isNaN(parseFloat(validateDecimals(e))) ? '0.00' : validateDecimals(e),
                                                    value: isNaN(parseFloat(validateDecimals({ e: e, languageId: languageObj?.id, subMethod: 'input - cost', }))) ? numberSet({ number: '0.00', type: 'd', languageId: languageObj?.id, subMethod: 'input - height', })?.result : validateDecimals({ e: e, languageId: languageObj?.id, subMethod: 'input - height', }),
                                                    subMethod: 'input - cost',
                                                })}
                                                onFocus={() => setCostError('')}
                                                value={inventory?.cost || '0.00'}
                                                tooltip='tooltip' title={labels?.cost?.[languageObj?.id]} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.dollarSign} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(costError)}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className='text-muted'>
                            <div className='row'>
                                <div className='col-md-4'>
                                    <b>{labels?.description?.[languageObj?.id]}:</b>
                                </div>
                                <div className='col-md-8'>
                                    {!isUndNullEmp({ data: inventory?.description, subMethod: 'label - description', })?.result ? inventory?.description : ''}
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-4'>
                                    <b>{labels?.brand?.[languageObj?.id]}:</b>
                                </div>
                                <div className='col-md-8'>
                                    {!isUndNullEmp({ data: inventory?.brand, subMethod: 'label - brand', })?.result ? inventory?.brand : ''}
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-4'>
                                    <b>{labels?.model?.[languageObj?.id]}:</b>
                                </div>
                                <div className='col-md-8'>
                                    {!isUndNullEmp({ data: inventory?.model, subMethod: 'label - model', })?.result ? inventory?.model : ''}
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-4'>
                                    <b>{labels?.manufactured?.[languageObj?.id]}:</b>
                                </div>
                                <div className='col-md-8'>
                                    {dateTimeFormatGlobalSet({
                                        date: !isUndNullEmp({ data: inventory?.manufactured, subMethod: 'label - manufactuted', })?.result ? inventory?.manufactured : new Date(),
                                        type: languageObj?.format?.date?.f1,
                                        format: 0,
                                        addTime: false,
                                        languageId: languageObj?.id,
                                        subMethod: 'label - manufactured'
                                    })?.result}
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-4'>
                                    <b>{labels?.serial?.[languageObj?.id]}:</b>
                                </div>
                                <div className='col-md-8'>
                                    {!isUndNullEmp({ data: inventory?.serial, subMethod: 'label - serial', })?.result ? inventory?.serial : ''}
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-4'>
                                    <b>{labels?.type?.[languageObj?.id]}:</b>
                                </div>
                                <div className='col-md-8'>
                                    {!isUndNullEmp({ data: inventory?.type, subMethod: 'label - type', })?.result ? inventory?.type : ''}
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-4'>
                                    <b>{labels?.cost?.[languageObj?.id]}:</b>
                                </div>
                                <div className='col-md-8'>
                                    {separatorsNumbersSet({
                                        number: !isUndNullEmp({ data: inventory?.cost, subMethod: 'label - cost', })?.result ? inventory?.cost : 0.00,
                                        withDecimals: true,
                                        consoleLogErrorShow: true,
                                        subMethod: 'label - cost',
                                    })?.result}
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-12'>
                                    <hr />
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-4'>
                                    <b>{labels?.date?.[languageObj?.id]}:</b>
                                </div>
                                <div className='col-md-8'>
                                    {dateTimeFormatGlobalSet({
                                        date: !isUndNullEmp({ data: inventory?.created, subMethod: 'label - created', })?.result ? inventory?.created : new Date(),
                                        type: languageObj?.format?.date?.f1,
                                        format: languageObj?.format?.time?.type,
                                        addTime: false,
                                        languageId: languageObj?.id,
                                        subMethod: 'label - created'
                                    })?.result}
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-4'>
                                    <b>{labels?.user?.[languageObj?.id]}:</b>
                                </div>
                                <div className='col-md-8'>
                                    {!isUndNullEmp({ data: processValues?.user, subMethod: 'label - user', })?.result ? `${processValues?.user?.firstName || ''} ${processValues?.user?.lastName || ''}` : ''}
                                </div>
                            </div>
                        </div>
                    }
                    {/* </div> */}

                    {/* Footer */}
                    {/* <div className='card-footer'>
                            <div className='form-group text-right'>
                                {processValues?.type !== 2 ?
                                    <button className='btn btn-outline-warning mx-1'
                                        tooltip='tooltip'
                                        title={processValues?.type === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                                        type='submit'>
                                        <i className={icons?.save}></i>
                                    </button> :
                                    <></>
                                }
                                <button className='btn btn-outline-success'
                                    tooltip='tooltip'
                                    title={labels?.close?.[languageObj?.id]}
                                    type='reset'
                                    onClick={() => defaultValueSetAsync(true)}>
                                    <i className={icons?.arrowCircleLeft}></i>
                                </button>
                            </div>
                        </div> */}

                    {/* </form> */}
                    {/* </div> */}
                </Modal.Body>

                <Modal.Footer>
                    <div className='form-group text-right'>
                        {processValues?.type !== 2 ?
                            <button id={controls?.buttons?.save?.id}
                                className={controls?.buttons?.save?.className}
                                tooltip='tooltip'
                                title={processValues?.type === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                                type='submit'>
                                <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                            </button> :
                            <></>
                        }
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.className}
                            tooltip='tooltip'
                            title={labels?.close?.[languageObj?.id]}
                            type='reset'
                            onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'modal - headerCloser', })}>
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}